import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCrown } from 'react-icons/fa';

const TokenBalance = ({ balance, isFounder, monthlyUsage = 0 }) => {
  if (isFounder) {
    return (
      <AnimatePresence>
        <motion.div 
          className="flex items-center gap-2"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: "spring", duration: 0.5 }}
        >
          <FaCrown className="text-yellow-500" />
        </motion.div>
      </AnimatePresence>
    );
  }

  // Always show balance, even if 0

  return (
    <AnimatePresence>
      <motion.div 
        className="flex items-center gap-2"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", duration: 0.5 }}
      >
        <svg 
          stroke="currentColor" 
          fill="currentColor" 
          strokeWidth="0" 
          viewBox="0 0 512 512" 
          className="text-yellow-500"
          height="1em" 
          width="1em" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"></path>
        </svg>
        <span className="font-['VT323'] text-[18px] text-black/40">
          {balance} tokens
        </span>
      </motion.div>
    </AnimatePresence>
  );
};

export default TokenBalance; 